<template>
  <div id="app">
    <b-table
      responsive
      hover
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :small="small"
      :dark="dark"
      :fixed="fixed"
      :foot-clone="footClone"
      :no-border-collapse="noCollapse"
      :items="items"
      :fields="fields"
      :head-variant="headVariant"
      :table-variant="tableVariant"
      class="text-xs-left table-no-margin-top w-100"
      show-empty
    >
      <template
        v-for="slot in Object.keys($scopedSlots)"
        v-slot:
        [toCellName(slot)]="props"
      >
        <slot v-bind="props" :name="slot" />
      </template>
      <template #empty="scope" style="text-align: center;">
        За выбранный период данные отсутствуют
      </template>
    </b-table>
  </div>
</template>

<script>
import EventHubListenerMixin from "../../common/mixins/EventHubListener";

export default {
  name: "ResultsTableOrganic",

  components: {EventHubListenerMixin},
  props: {
    fields: {
      type: Array,
      default: [],
    },
    items: {
      type: Array,
      default: [],
    },
  },

  data: function () {
    return {
      loading: true,
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: "",
      noCollapse: false,
    };
  },

  computed: {
    rows() {
      return this.items.length;
    }
  },

  methods: {
    toCellName(slot) {
      return `cell(${slot})`;
    },
  },
}
</script>

<style scoped>

</style>